/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v12.3.1.0 (NJsonSchema v9.14.1.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import { AbpServiceBase } from '../abp-service-base';

export class ConnectionServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * @return Success
     */
    findPcNodeList(): Promise<PcNodeDtoListApiResultDto> {
        let url_ = this.baseUrl + this.covertUrl('http://192.168.3.251/extranet-v2-serve')+ "/Connection/FindPcNodeList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processFindPcNodeList(_response);
        });
    }

    protected processFindPcNodeList(response: AxiosResponse): Promise<PcNodeDtoListApiResultDto> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? PcNodeDtoListApiResultDto.fromJS(resultData200) : new PcNodeDtoListApiResultDto();
            return result200;
        }
        return Promise.resolve<PcNodeDtoListApiResultDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    closePcNode(body: CloseNodeDto | null | undefined): Promise<BooleanApiResultDto> {
        let url_ = this.baseUrl + this.covertUrl('http://192.168.3.251/extranet-v2-serve')+ "/Connection/ClosePcNode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processClosePcNode(_response);
        });
    }

    protected processClosePcNode(response: AxiosResponse): Promise<BooleanApiResultDto> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? BooleanApiResultDto.fromJS(resultData200) : new BooleanApiResultDto();
            return result200;
        }
        return Promise.resolve<BooleanApiResultDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    closeGatewayNode(body: CloseNodeDto | null | undefined): Promise<BooleanApiResultDto> {
        let url_ = this.baseUrl + this.covertUrl('http://192.168.3.251/extranet-v2-serve')+ "/Connection/CloseGatewayNode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCloseGatewayNode(_response);
        });
    }

    protected processCloseGatewayNode(response: AxiosResponse): Promise<BooleanApiResultDto> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? BooleanApiResultDto.fromJS(resultData200) : new BooleanApiResultDto();
            return result200;
        }
        return Promise.resolve<BooleanApiResultDto>(<any>null);
    }

    /**
     * @return Success
     */
    findGatewayNodeList(): Promise<GatewayNodeDtoListApiResultDto> {
        let url_ = this.baseUrl + this.covertUrl('http://192.168.3.251/extranet-v2-serve')+ "/Connection/FindGatewayNodeList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processFindGatewayNodeList(_response);
        });
    }

    protected processFindGatewayNodeList(response: AxiosResponse): Promise<GatewayNodeDtoListApiResultDto> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? GatewayNodeDtoListApiResultDto.fromJS(resultData200) : new GatewayNodeDtoListApiResultDto();
            return result200;
        }
        return Promise.resolve<GatewayNodeDtoListApiResultDto>(<any>null);
    }

    /**
     * @return Success
     */
    findVChannelList(): Promise<ChannelInfoIEnumerableApiResultDto> {
        let url_ = this.baseUrl + this.covertUrl('http://192.168.3.251/extranet-v2-serve')+ "/Connection/FindVChannelList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processFindVChannelList(_response);
        });
    }

    protected processFindVChannelList(response: AxiosResponse): Promise<ChannelInfoIEnumerableApiResultDto> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ChannelInfoIEnumerableApiResultDto.fromJS(resultData200) : new ChannelInfoIEnumerableApiResultDto();
            return result200;
        }
        return Promise.resolve<ChannelInfoIEnumerableApiResultDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    closeVChannel(body: CloseVChannelDto | null | undefined): Promise<BooleanApiResultDto> {
        let url_ = this.baseUrl + this.covertUrl('http://192.168.3.251/extranet-v2-serve')+ "/Connection/CloseVChannel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCloseVChannel(_response);
        });
    }

    protected processCloseVChannel(response: AxiosResponse): Promise<BooleanApiResultDto> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? BooleanApiResultDto.fromJS(resultData200) : new BooleanApiResultDto();
            return result200;
        }
        return Promise.resolve<BooleanApiResultDto>(<any>null);
    }
}

export class VirtualConnectionServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * @param code (optional) 
     * @return Success
     */
    findConfig(code: string | null | undefined): Promise<VirtualConnectionInfo> {
        let url_ = this.baseUrl + this.covertUrl('http://192.168.3.251/extranet-v2-serve')+ "/VirtualConnection/FindConfig?";
        if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processFindConfig(_response);
        });
    }

    protected processFindConfig(response: AxiosResponse): Promise<VirtualConnectionInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? VirtualConnectionInfo.fromJS(resultData200) : new VirtualConnectionInfo();
            return result200;
        }
        return Promise.resolve<VirtualConnectionInfo>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    closeConnection(body: CloseConnectionDto | null | undefined): Promise<BooleanApiResultDto> {
        let url_ = this.baseUrl + this.covertUrl('http://192.168.3.251/extranet-v2-serve')+ "/VirtualConnection/CloseConnection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCloseConnection(_response);
        });
    }

    protected processCloseConnection(response: AxiosResponse): Promise<BooleanApiResultDto> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? BooleanApiResultDto.fromJS(resultData200) : new BooleanApiResultDto();
            return result200;
        }
        return Promise.resolve<BooleanApiResultDto>(<any>null);
    }
}

export class WeatherForecastServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * @return Success
     */
    get(): Promise<WeatherForecast[]> {
        let url_ = this.baseUrl + this.covertUrl('http://192.168.3.251/extranet-v2-serve')+ "/WeatherForecast";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<WeatherForecast[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WeatherForecast.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<WeatherForecast[]>(<any>null);
    }
}

export class BooleanApiResultDto implements IBooleanApiResultDto {
    code!: number | undefined;
    success!: boolean | undefined;
    msg!: string | undefined;
    data!: boolean | undefined;

    constructor(data?: IBooleanApiResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.success = data["success"];
            this.msg = data["msg"];
            this.data = data["data"];
        }
    }

    static fromJS(data: any): BooleanApiResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new BooleanApiResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["success"] = this.success;
        data["msg"] = this.msg;
        data["data"] = this.data;
        return data; 
    }
}

export interface IBooleanApiResultDto {
    code: number | undefined;
    success: boolean | undefined;
    msg: string | undefined;
    data: boolean | undefined;
}

export class ChannelInfo implements IChannelInfo {
    connectCode!: string | undefined;
    pcId!: string | undefined;
    gatewayId!: string | undefined;
    pcIp!: string | undefined;
    gatewayIp!: string | undefined;
    linkParamInfo!: string | undefined;
    connectTime!: Date | undefined;

    constructor(data?: IChannelInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.connectCode = data["connectCode"];
            this.pcId = data["pcId"];
            this.gatewayId = data["gatewayId"];
            this.pcIp = data["pcIp"];
            this.gatewayIp = data["gatewayIp"];
            this.linkParamInfo = data["linkParamInfo"];
            this.connectTime = data["connectTime"] ? new Date(data["connectTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ChannelInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ChannelInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["connectCode"] = this.connectCode;
        data["pcId"] = this.pcId;
        data["gatewayId"] = this.gatewayId;
        data["pcIp"] = this.pcIp;
        data["gatewayIp"] = this.gatewayIp;
        data["linkParamInfo"] = this.linkParamInfo;
        data["connectTime"] = this.connectTime ? this.connectTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IChannelInfo {
    connectCode: string | undefined;
    pcId: string | undefined;
    gatewayId: string | undefined;
    pcIp: string | undefined;
    gatewayIp: string | undefined;
    linkParamInfo: string | undefined;
    connectTime: Date | undefined;
}

export class ChannelInfoIEnumerableApiResultDto implements IChannelInfoIEnumerableApiResultDto {
    code!: number | undefined;
    success!: boolean | undefined;
    msg!: string | undefined;
    data!: ChannelInfo[] | undefined;

    constructor(data?: IChannelInfoIEnumerableApiResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.success = data["success"];
            this.msg = data["msg"];
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [] as any;
                for (let item of data["data"])
                    this.data!.push(ChannelInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ChannelInfoIEnumerableApiResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChannelInfoIEnumerableApiResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["success"] = this.success;
        data["msg"] = this.msg;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IChannelInfoIEnumerableApiResultDto {
    code: number | undefined;
    success: boolean | undefined;
    msg: string | undefined;
    data: ChannelInfo[] | undefined;
}

export class CloseConnectionDto implements ICloseConnectionDto {
    gatewayCode!: string | undefined;
    connectCode!: string | undefined;

    constructor(data?: ICloseConnectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.gatewayCode = data["gatewayCode"];
            this.connectCode = data["connectCode"];
        }
    }

    static fromJS(data: any): CloseConnectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CloseConnectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gatewayCode"] = this.gatewayCode;
        data["connectCode"] = this.connectCode;
        return data; 
    }
}

export interface ICloseConnectionDto {
    gatewayCode: string | undefined;
    connectCode: string | undefined;
}

export class CloseNodeDto implements ICloseNodeDto {
    nodeId!: string | undefined;

    constructor(data?: ICloseNodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.nodeId = data["nodeId"];
        }
    }

    static fromJS(data: any): CloseNodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CloseNodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nodeId"] = this.nodeId;
        return data; 
    }
}

export interface ICloseNodeDto {
    nodeId: string | undefined;
}

export class CloseVChannelDto implements ICloseVChannelDto {
    connectCode!: string | undefined;

    constructor(data?: ICloseVChannelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.connectCode = data["connectCode"];
        }
    }

    static fromJS(data: any): CloseVChannelDto {
        data = typeof data === 'object' ? data : {};
        let result = new CloseVChannelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["connectCode"] = this.connectCode;
        return data; 
    }
}

export interface ICloseVChannelDto {
    connectCode: string | undefined;
}

export class GatewayNodeDto implements IGatewayNodeDto {
    nodeId!: string | undefined;
    nodeKey!: string | undefined;
    networkAddress!: string | undefined;
    state!: string | undefined;
    loginTime!: Date | undefined;
    rxTraffic!: number | undefined;
    txTraffic!: number | undefined;
    readonly traffic!: number | undefined;
    readonly displayRxTraffic!: string | undefined;
    readonly displayTxTraffic!: string | undefined;
    readonly displayTraffic!: string | undefined;

    constructor(data?: IGatewayNodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.nodeId = data["nodeId"];
            this.nodeKey = data["nodeKey"];
            this.networkAddress = data["networkAddress"];
            this.state = data["state"];
            this.loginTime = data["loginTime"] ? new Date(data["loginTime"].toString()) : <any>undefined;
            this.rxTraffic = data["rxTraffic"];
            this.txTraffic = data["txTraffic"];
            (<any>this).traffic = data["traffic"];
            (<any>this).displayRxTraffic = data["displayRxTraffic"];
            (<any>this).displayTxTraffic = data["displayTxTraffic"];
            (<any>this).displayTraffic = data["displayTraffic"];
        }
    }

    static fromJS(data: any): GatewayNodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new GatewayNodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nodeId"] = this.nodeId;
        data["nodeKey"] = this.nodeKey;
        data["networkAddress"] = this.networkAddress;
        data["state"] = this.state;
        data["loginTime"] = this.loginTime ? this.loginTime.toISOString() : <any>undefined;
        data["rxTraffic"] = this.rxTraffic;
        data["txTraffic"] = this.txTraffic;
        data["traffic"] = this.traffic;
        data["displayRxTraffic"] = this.displayRxTraffic;
        data["displayTxTraffic"] = this.displayTxTraffic;
        data["displayTraffic"] = this.displayTraffic;
        return data; 
    }
}

export interface IGatewayNodeDto {
    nodeId: string | undefined;
    nodeKey: string | undefined;
    networkAddress: string | undefined;
    state: string | undefined;
    loginTime: Date | undefined;
    rxTraffic: number | undefined;
    txTraffic: number | undefined;
    traffic: number | undefined;
    displayRxTraffic: string | undefined;
    displayTxTraffic: string | undefined;
    displayTraffic: string | undefined;
}

export class GatewayNodeDtoListApiResultDto implements IGatewayNodeDtoListApiResultDto {
    code!: number | undefined;
    success!: boolean | undefined;
    msg!: string | undefined;
    data!: GatewayNodeDto[] | undefined;

    constructor(data?: IGatewayNodeDtoListApiResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.success = data["success"];
            this.msg = data["msg"];
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [] as any;
                for (let item of data["data"])
                    this.data!.push(GatewayNodeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GatewayNodeDtoListApiResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new GatewayNodeDtoListApiResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["success"] = this.success;
        data["msg"] = this.msg;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGatewayNodeDtoListApiResultDto {
    code: number | undefined;
    success: boolean | undefined;
    msg: string | undefined;
    data: GatewayNodeDto[] | undefined;
}

export class PcNodeDto implements IPcNodeDto {
    nodeId!: string | undefined;
    nodeKey!: string | undefined;
    networkAddress!: string | undefined;
    state!: string | undefined;
    loginTime!: Date | undefined;
    rxTraffic!: number | undefined;
    txTraffic!: number | undefined;
    readonly traffic!: number | undefined;
    readonly displayRxTraffic!: string | undefined;
    readonly displayTxTraffic!: string | undefined;
    readonly displayTraffic!: string | undefined;

    constructor(data?: IPcNodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.nodeId = data["nodeId"];
            this.nodeKey = data["nodeKey"];
            this.networkAddress = data["networkAddress"];
            this.state = data["state"];
            this.loginTime = data["loginTime"] ? new Date(data["loginTime"].toString()) : <any>undefined;
            this.rxTraffic = data["rxTraffic"];
            this.txTraffic = data["txTraffic"];
            (<any>this).traffic = data["traffic"];
            (<any>this).displayRxTraffic = data["displayRxTraffic"];
            (<any>this).displayTxTraffic = data["displayTxTraffic"];
            (<any>this).displayTraffic = data["displayTraffic"];
        }
    }

    static fromJS(data: any): PcNodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new PcNodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nodeId"] = this.nodeId;
        data["nodeKey"] = this.nodeKey;
        data["networkAddress"] = this.networkAddress;
        data["state"] = this.state;
        data["loginTime"] = this.loginTime ? this.loginTime.toISOString() : <any>undefined;
        data["rxTraffic"] = this.rxTraffic;
        data["txTraffic"] = this.txTraffic;
        data["traffic"] = this.traffic;
        data["displayRxTraffic"] = this.displayRxTraffic;
        data["displayTxTraffic"] = this.displayTxTraffic;
        data["displayTraffic"] = this.displayTraffic;
        return data; 
    }
}

export interface IPcNodeDto {
    nodeId: string | undefined;
    nodeKey: string | undefined;
    networkAddress: string | undefined;
    state: string | undefined;
    loginTime: Date | undefined;
    rxTraffic: number | undefined;
    txTraffic: number | undefined;
    traffic: number | undefined;
    displayRxTraffic: string | undefined;
    displayTxTraffic: string | undefined;
    displayTraffic: string | undefined;
}

export class PcNodeDtoListApiResultDto implements IPcNodeDtoListApiResultDto {
    code!: number | undefined;
    success!: boolean | undefined;
    msg!: string | undefined;
    data!: PcNodeDto[] | undefined;

    constructor(data?: IPcNodeDtoListApiResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.success = data["success"];
            this.msg = data["msg"];
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [] as any;
                for (let item of data["data"])
                    this.data!.push(PcNodeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PcNodeDtoListApiResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PcNodeDtoListApiResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["success"] = this.success;
        data["msg"] = this.msg;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPcNodeDtoListApiResultDto {
    code: number | undefined;
    success: boolean | undefined;
    msg: string | undefined;
    data: PcNodeDto[] | undefined;
}

export class VirtualConnectionInfo implements IVirtualConnectionInfo {
    success!: boolean | undefined;
    connectionParameter!: any | undefined;
    vLinkParameterList!: any[] | undefined;

    constructor(data?: IVirtualConnectionInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.success = data["success"];
            this.connectionParameter = data["connectionParameter"];
            if (data["vLinkParameterList"] && data["vLinkParameterList"].constructor === Array) {
                this.vLinkParameterList = [] as any;
                for (let item of data["vLinkParameterList"])
                    this.vLinkParameterList!.push(item);
            }
        }
    }

    static fromJS(data: any): VirtualConnectionInfo {
        data = typeof data === 'object' ? data : {};
        let result = new VirtualConnectionInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["connectionParameter"] = this.connectionParameter;
        if (this.vLinkParameterList && this.vLinkParameterList.constructor === Array) {
            data["vLinkParameterList"] = [];
            for (let item of this.vLinkParameterList)
                data["vLinkParameterList"].push(item);
        }
        return data; 
    }
}

export interface IVirtualConnectionInfo {
    success: boolean | undefined;
    connectionParameter: any | undefined;
    vLinkParameterList: any[] | undefined;
}

export class WeatherForecast implements IWeatherForecast {
    date!: Date | undefined;
    temperatureC!: number | undefined;
    readonly temperatureF!: number | undefined;
    summary!: string | undefined;

    constructor(data?: IWeatherForecast) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.date = data["date"] ? new Date(data["date"].toString()) : <any>undefined;
            this.temperatureC = data["temperatureC"];
            (<any>this).temperatureF = data["temperatureF"];
            this.summary = data["summary"];
        }
    }

    static fromJS(data: any): WeatherForecast {
        data = typeof data === 'object' ? data : {};
        let result = new WeatherForecast();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["temperatureC"] = this.temperatureC;
        data["temperatureF"] = this.temperatureF;
        data["summary"] = this.summary;
        return data; 
    }
}

export interface IWeatherForecast {
    date: Date | undefined;
    temperatureC: number | undefined;
    temperatureF: number | undefined;
    summary: string | undefined;
}